/**
 * 接口状态码处理
 * Created by kahn on 2018/4/20.
 */
import { MessageBox, Message  } from 'element-ui';

const codeArray = {
    'success': '200',             //请求成功
    'loginInvalid': '400',      //登录失效，重新登录
};

//状态码处理和执行回调
const dealCode = (options = {}) => {
    let _options = {
        code: '',
        successCallback: () => {},      //正常业务回调
        errorDeal: () => {},          //异常业务回调
        completeDeal: () => {}        //所有业务处理完毕回调
    }
    let config = Object.assign(_options, options);

    //判断是否传了状态码
    if(!config.code) {
        console.log('接口返回码未传');
        return;
    }

    switch(config.code)
    {
        case codeArray.success:
            if(config.successCallback && typeof config.successCallback === 'function') {
                config.completeDeal();
                config.successCallback();
            }else {
                console.log('请添加successCallback参数');
            }
            break;
        case codeArray.loginInvalid:
            window.localStorage.clear();
            window.sessionStorage.clear();
            MessageBox.alert('登录已失效，请重新登录!', {
                type: 'error', 
                onClose: () => {
                    window.location.href = '/login';
                }
            });
            break;
        default:
            config.completeDeal();
            config.errorDeal();
            break;
    }

    

};

//判断状态码是否在cdoeArray里面
const isInCodeArray = o => {
    for(let i in codeArray){
        if (o == parseInt(codeArray[i])) {
            return true;
        };
    }
    return false;
}

export { dealCode }


// WEBPACK FOOTER //
// ./src/js/lib/dealCode.js